module.exports = __webpack_public_path__ + "static/img/fujiq_a.5801f30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/present/fujiq_a.png
// module id = yg/X
// module chunks = 0